import { render, staticRenderFns } from "./CompanyManager.vue?vue&type=template&id=66b9a1bc"
import script from "./CompanyManager.vue?vue&type=script&lang=js"
export * from "./CompanyManager.vue?vue&type=script&lang=js"
import style0 from "./CompanyManager.vue?vue&type=style&index=0&id=66b9a1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports